import { Link } from 'react-router';
import { dsClass } from '../../common/constants/dsClasses';
import { paths } from '../../common/constants/pathVariables';
import { t } from '../../common/i18n';
import { Grid } from '../Grid/Grid';
import type { JSX } from 'react';

export const PublicMobileVoiceFeatureHighlights = (): JSX.Element => (
  <Grid colWidthL={10}>
    <p className={`${dsClass.TEXT_ALIGN_CENTER} ${dsClass.TEXT_M}`}>
      <small>
        {t.FZ4O('Already a customer? Sign in to ')}
        <Link className={dsClass.LINK} to={paths.SELF_SERVICE_HOME}>
          {t.AREB('OmaElisa for Companies')}
        </Link>
        {t.DED6(` to easily manage and activate your subscriptions and add-on services.`)}
      </small>
    </p>
  </Grid>
);
